import { Model, View } from '@lernetz/ts-lib';
import { Subscription } from '@lernetz/ts-lib/src/Signal';
import { ViewConfig } from '@lernetz/ts-lib/src/view/View';

import { createFocusTrap, FocusTrap } from 'focus-trap';

import template from './PopupContainer.html';

export class PopupContainer extends Model {

    public popup: object;

    public close(): void {
        document.body.style.overflow = '';
        this.popup = null;
    }

    public show(popup: object): void {
        if (!this.popup) {
            setTimeout(() => {
                document.body.style.overflow = 'hidden';
            }, 126);
        }

        this.popup = popup;
    }
}

export class PopupContainerView extends View<PopupContainer> {

    private subscription: Subscription;
    private focusTrap: FocusTrap;
    
    public constructor(config?: ViewConfig<PopupContainer>) {
        super({ template, ...config });
    }

    init() {
        this.subscription = this.data.propertyChange.filter(p => p.name === 'popup').subscribe(() => this.onPopupChanged());
    }

    deinit() {
        this.subscription?.unsubscribe();
    }

    private onPopupChanged() {
        if (this.focusTrap) {
            this.focusTrap.deactivate(this.data.popup ? {
                onDeactivate: () => {}
            } : void 0);
            this.focusTrap = null;
        }

        if (this.data.popup) {
            setTimeout(() => {
                const popupNode = this.node.querySelector<HTMLElement>('[js-popup]');
                if (popupNode) {
                    this.focusTrap = createFocusTrap(popupNode, {
                        onDeactivate: () => this.data.close(),
                        clickOutsideDeactivates: true,
                    });
                    this.focusTrap.activate();
                }
            }, 250);
        }
    }
}
